import type { LibraryBlock } from "../build";
import {
  CARD_SHADOW,
  ellipse,
  icon,
  motion,
  pill,
  rect,
  SHADOW,
  shape,
  text,
  WHITE,
} from "./helpers";

export const STICKERS: LibraryBlock[] = [
  {
    id: "sticker-neu",
    title: "NEU",
    category: "sticker",
    width: 260,
    height: 260,
    anchor: "top-right",
    duration: 3500,
    nodes: [
      shape("star", {
        x: 0,
        y: 0,
        w: 260,
        h: 260,
        fill: "accent",
        sides: 12,
        innerRatio: 0.8,
        name: "Stern",
        ...motion("spin", { duration: 700, loop: "pulse" }),
      }),
      text({
        text: "NEU",
        style: "heading-1",
        size: 76,
        color: "on:accent",
        x: 20,
        y: 0,
        w: 220,
        h: 260,
        align: "center",
        rotation: -10,
        ...motion("spin", { duration: 700, loop: "pulse" }),
      }),
    ],
  },
  {
    id: "sticker-rabatt",
    title: "Rabatt",
    category: "sticker",
    width: 300,
    height: 300,
    anchor: "top-right",
    duration: 3500,
    nodes: [
      ellipse({
        x: 0,
        y: 0,
        w: 300,
        h: 300,
        fill: "primary",
        name: "Kreis",
        ...motion("pop", { loop: "wiggle" }),
      }),
      text({
        // Non-breaking space: number and sign stay on one line.
        text: "−20\u00a0%",
        style: "heading-1",
        size: 80,
        color: "on:primary",
        x: 20,
        y: 0,
        w: 260,
        h: 210,
        align: "center",
        ...motion("pop", { loop: "wiggle" }),
      }),
      text({
        text: "auf alles",
        style: "subline",
        size: 30,
        color: "on:primary/80",
        x: 20,
        y: 175,
        w: 260,
        align: "center",
        ...motion("pop", { loop: "wiggle" }),
      }),
    ],
  },
  {
    id: "sticker-live",
    title: "LIVE",
    category: "sticker",
    width: 250,
    height: 84,
    anchor: "top-left",
    duration: 5000,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 250,
        h: 84,
        fill: "#dc2626",
        radius: "sm",
        name: "Fläche",
        ...motion("pop"),
      }),
      ellipse({
        x: 26,
        y: 29,
        w: 26,
        h: 26,
        fill: WHITE,
        name: "Punkt",
        ...motion("fade", { loop: "pulse" }),
      }),
      text({
        text: "LIVE",
        style: "heading-2",
        size: 44,
        color: WHITE,
        x: 70,
        y: 0,
        w: 160,
        h: 84,
        align: "center",
        ...motion("pop"),
      }),
    ],
  },
  {
    id: "sticker-pfeil",
    title: "Pfeil",
    category: "sticker",
    width: 360,
    height: 120,
    anchor: "center",
    duration: 3500,
    nodes: [
      rect({
        x: 0,
        y: 40,
        w: 260,
        h: 40,
        fill: "accent",
        radius: "full",
        name: "Schaft",
        ...motion("fly-right", { loop: "float" }),
      }),
      shape("triangle", {
        x: 230,
        y: 0,
        w: 130,
        h: 120,
        fill: "accent",
        rotation: 90,
        name: "Spitze",
        ...motion("fly-right", { loop: "float" }),
      }),
    ],
  },
  {
    id: "sticker-achtung",
    title: "Achtung",
    category: "sticker",
    width: 240,
    height: 220,
    anchor: "top-right",
    duration: 3500,
    nodes: [
      shape("triangle", {
        x: 0,
        y: 0,
        w: 240,
        h: 220,
        fill: "accent",
        name: "Dreieck",
        ...motion("drop", { duration: 800, loop: "wiggle" }),
      }),
      text({
        text: "!",
        style: "heading-1",
        size: 120,
        color: "on:accent",
        x: 60,
        y: 50,
        w: 120,
        h: 160,
        align: "center",
        ...motion("drop", { duration: 800, loop: "wiggle" }),
      }),
    ],
  },
  {
    id: "sticker-nur-heute",
    title: "Nur heute",
    category: "sticker",
    width: 420,
    height: 130,
    anchor: "top-right",
    duration: 3500,
    nodes: [
      ...pill(
        0,
        0,
        420,
        130,
        "NUR HEUTE",
        "secondary",
        48,
        { ...motion("pop"), rotation: -8 },
        {
          style: "heading-2",
        },
      ),
    ],
  },
  {
    id: "sticker-top",
    title: "Top-Siegel",
    category: "sticker",
    width: 280,
    height: 280,
    anchor: "top-right",
    duration: 3500,
    nodes: [
      ellipse({
        x: 0,
        y: 0,
        w: 280,
        h: 280,
        fill: "background",
        stroke: { color: "primary", width: 10, dash: "dashed" },
        name: "Siegel",
        ...motion("spin", { duration: 800 }),
      }),
      text({
        text: "TOP",
        style: "subline",
        size: 38,
        color: "primary",
        x: 30,
        y: 62,
        w: 220,
        align: "center",
        ...motion("spin", { duration: 800 }),
      }),
      text({
        text: "3",
        style: "heading-1",
        size: 120,
        color: "primary",
        x: 30,
        y: 100,
        w: 220,
        align: "center",
        ...motion("spin", { duration: 800 }),
      }),
    ],
  },
  {
    id: "sticker-gratis",
    title: "GRATIS",
    category: "sticker",
    tags: ["kostenlos", "umsonst", "free", "Angebot"],
    width: 280,
    height: 280,
    anchor: "top-right",
    duration: 3500,
    nodes: [
      shape("star", {
        x: 0,
        y: 0,
        w: 280,
        h: 280,
        fill: "primary",
        sides: 16,
        innerRatio: 0.86,
        name: "Zacken",
        ...motion("spin", { duration: 700, loop: "wiggle" }),
      }),
      text({
        text: "GRATIS",
        style: "heading-1",
        size: 64,
        color: "on:primary",
        x: 30,
        y: 0,
        w: 220,
        h: 280,
        align: "center",
        rotation: -8,
        ...motion("spin", { duration: 700, loop: "wiggle" }),
      }),
    ],
  },
  {
    id: "sticker-bestseller",
    title: "Bestseller",
    category: "sticker",
    tags: ["beliebt", "Krone", "Favorit", "meistverkauft", "Top"],
    width: 420,
    height: 240,
    anchor: "top-right",
    duration: 3500,
    nodes: [
      ...pill(
        0,
        110,
        420,
        110,
        "BESTSELLER",
        "primary",
        42,
        { ...motion("pop"), rotation: -4 },
        {
          style: "heading-2",
        },
      ),
      icon({
        icon: "crown",
        x: 150,
        y: 0,
        w: 120,
        h: 120,
        color: "accent",
        rotation: -4,
        shadow: { color: "#00000040", y: 4, blur: 12 },
        name: "Krone",
        ...motion("drop", { delay: 250, duration: 700 }),
      }),
    ],
  },
  {
    id: "sticker-sterne",
    title: "5 Sterne",
    category: "sticker",
    tags: ["Bewertung", "Rezension", "Sterne", "Google", "Qualität"],
    width: 560,
    height: 190,
    anchor: "top",
    duration: 4000,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 560,
        h: 190,
        fill: "background",
        radius: "lg",
        shadow: CARD_SHADOW,
        name: "Karte",
        ...motion("pop"),
      }),
      ...[0, 1, 2, 3, 4].map((index) =>
        icon({
          icon: "star",
          x: 40 + index * 100,
          y: 24,
          w: 80,
          h: 80,
          color: "accent",
          name: `Stern ${index + 1}`,
          ...motion("pop", { delay: 150 + index * 120 }),
        }),
      ),
      text({
        text: "4,9 von 5 · 320 Bewertungen",
        style: "caption",
        size: 28,
        color: "text-muted",
        x: 20,
        y: 124,
        w: 520,
        align: "center",
        ...motion("fade", { delay: 800 }),
      }),
    ],
  },
  {
    id: "sticker-minus-50",
    title: "−50 % Sale",
    category: "sticker",
    tags: ["Rabatt", "Sale", "Prozent", "reduziert", "Angebot"],
    width: 320,
    height: 320,
    anchor: "top-right",
    duration: 3500,
    nodes: [
      rect({
        x: 20,
        y: 20,
        w: 280,
        h: 280,
        fill: "primary",
        radius: "md",
        rotation: 8,
        name: "Fläche",
        ...motion("pop", { loop: "wiggle" }),
      }),
      text({
        text: "−50 %",
        style: "heading-1",
        size: 96,
        color: "on:primary",
        x: 30,
        y: 60,
        w: 260,
        h: 150,
        align: "center",
        rotation: 8,
        ...motion("pop", { loop: "wiggle" }),
      }),
      text({
        text: "SALE",
        style: "subline",
        size: 40,
        color: "on:primary/80",
        x: 30,
        y: 200,
        w: 260,
        align: "center",
        rotation: 8,
        ...motion("pop", { loop: "wiggle" }),
      }),
    ],
  },
  {
    id: "sticker-pfeil-kurve",
    title: "Pfeil gebogen",
    category: "sticker",
    tags: ["Pfeil", "hier", "zeigen", "Hinweis", "Handschrift"],
    width: 360,
    height: 370,
    anchor: "center",
    duration: 3500,
    nodes: [
      text({
        text: "Hier!",
        style: "quote",
        size: 84,
        color: "accent",
        shadow: SHADOW,
        x: 0,
        y: 0,
        w: 360,
        align: "center",
        rotation: -6,
        ...motion("pop"),
      }),
      icon({
        icon: "arrow-bend-right-down",
        x: 80,
        y: 120,
        w: 240,
        h: 240,
        color: "accent",
        shadow: SHADOW,
        name: "Pfeil",
        ...motion("fade", { delay: 200, loop: "float" }),
      }),
    ],
  },
  {
    id: "sticker-herz",
    title: "Herz mit Funkeln",
    category: "sticker",
    tags: ["Liebe", "Herz", "Like", "Lieblingsstück", "Emoji"],
    width: 290,
    height: 290,
    anchor: "top-right",
    duration: 3500,
    nodes: [
      icon({
        icon: "heart",
        x: 10,
        y: 30,
        w: 250,
        h: 250,
        color: "primary",
        shadow: { color: "#00000033", y: 8, blur: 24 },
        name: "Herz",
        ...motion("pop", { duration: 600, loop: "pulse" }),
      }),
      icon({
        icon: "sparkle",
        x: 210,
        y: 0,
        w: 80,
        h: 80,
        color: "accent",
        name: "Funkeln",
        ...motion("spin", { delay: 300 }),
      }),
      icon({
        icon: "sparkle",
        x: 0,
        y: 200,
        w: 56,
        h: 56,
        color: "accent",
        name: "Funkeln",
        ...motion("spin", { delay: 450 }),
      }),
    ],
  },
  {
    id: "sticker-trend",
    title: "Trend",
    category: "sticker",
    tags: ["heiß", "Feuer", "angesagt", "hot", "viral", "Emoji"],
    width: 380,
    height: 130,
    anchor: "top-left",
    duration: 3500,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 380,
        h: 130,
        fill: "#111111",
        radius: "full",
        name: "Pille",
        ...motion("pop", { loop: "wiggle" }),
      }),
      icon({
        icon: "fire",
        x: 22,
        y: 15,
        w: 100,
        h: 100,
        color: "#f97316",
        name: "Feuer",
        ...motion("pop", { loop: "wiggle" }),
      }),
      text({
        text: "TREND",
        style: "heading-2",
        size: 56,
        color: WHITE,
        x: 130,
        y: 0,
        w: 220,
        h: 130,
        align: "center",
        ...motion("pop", { loop: "wiggle" }),
      }),
    ],
  },
  {
    id: "sticker-seit",
    title: "Seit-Siegel",
    category: "sticker",
    tags: ["Tradition", "Jubiläum", "gegründet", "Familienbetrieb", "Jahr"],
    width: 300,
    height: 300,
    anchor: "top-right",
    duration: 3500,
    nodes: [
      ellipse({
        x: 0,
        y: 0,
        w: 300,
        h: 300,
        fill: "primary",
        name: "Siegel",
        ...motion("spin", { duration: 800 }),
      }),
      ellipse({
        x: 16,
        y: 16,
        w: 268,
        h: 268,
        stroke: { color: "on:primary", width: 4, dash: "dashed" },
        name: "Ring",
        ...motion("spin", { duration: 800 }),
      }),
      text({
        text: "SEIT",
        style: "subline",
        size: 34,
        color: "on:primary",
        x: 30,
        y: 64,
        w: 240,
        align: "center",
        ...motion("spin", { duration: 800 }),
      }),
      text({
        text: "2014",
        style: "heading-1",
        size: 96,
        color: "on:primary",
        x: 30,
        y: 104,
        w: 240,
        align: "center",
        ...motion("spin", { duration: 800 }),
      }),
      text({
        text: "Familienbetrieb",
        style: "caption",
        size: 24,
        color: "on:primary/80",
        x: 40,
        y: 210,
        w: 220,
        align: "center",
        ...motion("spin", { duration: 800 }),
      }),
    ],
  },
  {
    id: "sticker-smiley",
    title: "Smiley",
    category: "sticker",
    tags: ["Emoji", "lachen", "fröhlich", "Gesicht", "gute Laune"],
    width: 240,
    height: 240,
    anchor: "top-right",
    duration: 3500,
    nodes: [
      ellipse({
        x: 40,
        y: 40,
        w: 160,
        h: 160,
        fill: "#18181b",
        name: "Gesicht",
        ...motion("drop", { duration: 800, loop: "wiggle" }),
      }),
      icon({
        icon: "smiley",
        x: 0,
        y: 0,
        w: 240,
        h: 240,
        color: "accent",
        name: "Smiley",
        ...motion("drop", { duration: 800, loop: "wiggle" }),
      }),
    ],
  },
  {
    id: "sticker-limitiert",
    title: "Limitiert",
    category: "sticker",
    tags: ["begrenzt", "Stückzahl", "exklusiv", "knapp", "Edition"],
    width: 460,
    height: 130,
    anchor: "top-right",
    duration: 3500,
    nodes: [
      rect({
        x: 0,
        y: 0,
        w: 460,
        h: 130,
        fill: "background",
        stroke: { color: "primary", width: 5, dash: "dashed" },
        radius: "full",
        rotation: -6,
        name: "Siegel",
        ...motion("pop"),
      }),
      text({
        text: "LIMITIERT",
        style: "heading-2",
        size: 44,
        color: "primary",
        x: 40,
        y: 14,
        w: 380,
        h: 62,
        align: "center",
        rotation: -6,
        ...motion("pop"),
      }),
      text({
        text: "nur 50 Stück",
        style: "caption",
        size: 26,
        color: "text-muted",
        x: 40,
        y: 74,
        w: 380,
        h: 40,
        align: "center",
        rotation: -6,
        ...motion("pop"),
      }),
    ],
  },
];
